/***************************************************************************************************

 Copyright 2023-2024 Fannie Mae. All rights reserved.
 This software contains confidential information and trade secrets of Fannie Mae.
 Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.

 ****************************************************************************************************/

import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { EndpointsService } from '../services/endpoints.service';
import { apiEndpoints } from '../../environments/environment';
import { formatDate } from "@angular/common";

@Injectable()
export class Utils {
  constructor(private endpointsService: EndpointsService, @Inject(LOCALE_ID) public locale: string) {
  };

  logout() {
    sessionStorage.clear();
    window.sessionStorage.clear(); // Just making sure this gets cleared in all browsers
    window.localStorage.clear();
    window.location.href = this.endpointsService.logoutFromApp();
  }

  login() {
    sessionStorage.clear();
    window.sessionStorage.clear(); // Just making sure this gets cleared in all browsers
    window.localStorage.clear();
    window.location.href = apiEndpoints[window.location.hostname].loginUrl;
  }

  public getBoolean(value) {
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  }

  public formatDate(value: Date, format: string) {
    return new Date(formatDate(value, format, this.locale, 'GMT'));
  }

  public removeArrayObjectWithId(arr, id) {
    return arr.filter((obj) => {
      return (obj.id !== id)
    });
  }

  public getUserType(isInternal: boolean, isAssetManager: boolean, isMAUser: boolean, isMFOpsUser: boolean) {
    if (isAssetManager)
      return 'a';
    else if (isMAUser)
      return 'ma';
    else if (isMFOpsUser)
      return 'ops';
    else if (isInternal)
      return 'i';
    else
      return '';
  }

  public getFormattedDate(date: string | Date): string {
    if (!date) return '';
  
    const parsedDate = new Date(date);
    const year = parsedDate.getUTCFullYear();
    const month = (parsedDate.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = parsedDate.getUTCDate().toString().padStart(2, '0');
  
    return `${month}/${day}/${year}`;
  }

  public getFormattedDateWithHhMmSs(date: string | Date) {
  if (date == null) {
    return date;
  }
  // If date is a string, convert to Date object
  if (typeof date === 'string') {
    // Replace space with 'T' for ISO format if needed
    if (date.indexOf('T') === -1 && date.indexOf(' ') > -1) {
      date = date.replace(' ', 'T');
    }
    date = new Date(date);
  }
  if (isNaN(date.getTime())) {
    return ''; // or handle invalid date as needed
  }
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
}
}
